import { Directive, input } from '@angular/core';

export type VirtualKeyboardMode = 'default' | 'numeric';

export const VIRTUAL_KEYBOARD_MODE_ATTRIBUTE = 'data-cue-virtual-keyboard-mode';

@Directive({
  selector: 'input[cueVirtualKeyboardMode], textarea[cueVirtualKeyboardMode]',
  standalone: true,
  host: {
    '[attr.data-cue-virtual-keyboard-mode]': 'cueVirtualKeyboardMode()',
  },
})
export class VirtualKeyboardModeDirective {
  readonly cueVirtualKeyboardMode = input.required<VirtualKeyboardMode>();
}
